/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, timer} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {IS_TEST_ENVIRONMENT} from '../../shared/utils/is-test-environment';

@Injectable({providedIn: 'root'})

export class PendingRequestsInterceptor implements HttpInterceptor {

    private readonly LAG_TIME = 500;
    private pendingRequestCount = 0;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!IS_TEST_ENVIRONMENT) {
            return next.handle(req);
        }

        this.increment();
        return next.handle(req).pipe(
                finalize(() => {
                    // Lag the decrement so an increment can happen before it. This is similar to a debounce.
                    // Timer will always complete after the given time, so there's no need to manage the subscription.
                    timer(this.LAG_TIME).subscribe(() => this.decrement());
                })
        );
    }

    private increment = (): void => {
        (window as any).pendingRequestCount = ++this.pendingRequestCount;
    };

    private decrement = (): void => {
        (window as any).pendingRequestCount = --this.pendingRequestCount;
    };
}
